const spaceVariants = {
    NORMAL: 'normal',
    COMFORT: 'comfort',
    COMPACT: 'compact',
};

export default spaceVariants;
